import { CommonTranslations } from "./models/common-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR"
import { enUS } from "./translactions/en-US"

export const common: Record<SupportedLanguages, CommonTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
